import React from 'react';
import _ from 'lodash';
import WorkApprovalService from '../../services/WorkApprovals';
import WorkScheduleService from '../../services/Works';
import { APPROVAL_STATUS, WORKER_TYPES } from '../../utilities/constants';
import UserProfileService from '../../services/UserProfiles';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import { isPrimaryCompanyRoleId } from '../../utilities/roleUtility';
import { messageUtility } from '../../utilities/messageUtility';

/**
 * 承認ダイアログ
 *  タイトル：請負/常傭
 *  内容：    スタンプボタン
 */

class WorkApproval extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      roleId: LocalStorageService.getRoleId(),
      reload: false,
      dayWorkerType: 0,
      approvalPersonList: [],
    };
  }
  componentDidMount() {
    this.getApprovalStatus();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.reload !== this.state.reload && this.state.reload === true) {
      this.getApprovalStatus();
      this.setState({ reload: false });
    }
  }

  /**
   * @description ハンコ承認状態設定
   * @param {number} approvedStatus 承認ステータス
   * @param {number} workApprovalId 承認ID
   */
  handleWorkApproval = (approvedStatus, workApprovalId) => {
    if (approvedStatus === APPROVAL_STATUS.approval.id) {
      return this.props.onCancelWorkApproval(workApprovalId);
    }
    UserProfileService.show(LocalStorageService.getUserId(), {}).then(
      response => {
        if (response.result === false) {
          return;
        }
        const userProfile = response.data.entities.user_profile;
        const firstName = userProfile.name_mei; // ユーザの名前
        const lastName = userProfile.name_sei; // ユーザの苗字
        WorkApprovalService.workApproval(
          this.props.fieldId,
          [this.props.workId],
          firstName,
          lastName
        ).then(response => {
          const errorCode = _.get(response, 'data.data.entities.error_code');
          if (errorCode) {
            this.props.onClose();
            this.props.onApproved();
            return this.props.onShowDialogDeniedApproval(
              messageUtility.getMessage('E-001-446'),
              messageUtility.getMessage(errorCode)
            );
          }
          if (response.result === true) {
            this.setState({ reload: true });
            this.props.onApproved && this.props.onApproved();
          }
        });
      }
    );
  };

  // 契約(請負/常傭)
  dayWorkerType(type) {
    switch (type) {
      case WORKER_TYPES.contractor.id:
        return WORKER_TYPES.contractor.name;
      case WORKER_TYPES.regular.id:
        return WORKER_TYPES.regular.name;
      default:
        return '';
    }
  }

  getApprovalStatus() {
    WorkScheduleService.show(this.props.fieldId, this.props.workId).then(
      response => {
        if (!response.result) {
          return;
        }
        const dayWorkerType = response.data.entities.work.dayworker_type;
        this.setState({ dayWorkerType });
      }
    );
    WorkApprovalService.list(this.props.fieldId, this.props.workId).then(
      response => {
        if (!response.result) {
          return;
        }
        const workApprovals = response.data.entities.work_approvals;
        this.setState({ approvalPersonList: workApprovals });
      }
    );
  }

  renderStamp(workApproval) {
    const uid = _.uniqueId();
    return (
      <div key={uid} className='toggle-stamp'>
        <div className='toggle-stamp__label'>
          <span className='label'>{workApproval.short_name}</span>
        </div>
        <label htmlFor={`check-stamp${uid}`}>
          <input
            id={`check-stamp${uid}`}
            type='checkbox'
            value={workApproval.id}
            checked={workApproval.approved === APPROVAL_STATUS.approval.id}
            onChange={() => {
              // 自動ロック時は承認解除する(支店管理者,現場監督に限る)
              if (
                this.props.workApprovalButtonEnabled &&
                this.props.autoLock &&
                isPrimaryCompanyRoleId(this.state.roleId)
              ) {
                return this.props.onCancelWorkApproval(workApproval.id);
              }
              // 承認権限があり、自動ロック状態ではない場合承認、承認解除する(支店管理者,現場監督に限る)
              if (
                workApproval.is_operatable &&
                !this.props.autoLock &&
                isPrimaryCompanyRoleId(this.state.roleId)
              ) {
                this.handleWorkApproval(workApproval.approved, workApproval.id);
              }
            }}
          />
          <div className='stamp'>
            {this.props.autoLock ? (
              <div
                className={'auto__lock auto__lock--check'}
                style={{ height: '32px', width: '35px', overflow: 'hidden' }}
              >
                <React.Fragment>
                  自動
                  <br />
                  ロック
                </React.Fragment>
              </div>
            ) : (
              <div
                className='stamp__name'
                style={{ height: '32px', width: '32px', overflow: 'hidden' }}
              >
                {Number(workApproval.approved) ===
                APPROVAL_STATUS.approval.id ? (
                  <React.Fragment>
                    {workApproval.user_name_sei}
                    <br />
                    {workApproval.user_name_mei}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    押印
                    <br />
                    なし
                  </React.Fragment>
                )}
              </div>
            )}
          </div>
        </label>
      </div>
    );
  }

  render() {
    return (
      <div className='dialog dialog--modal'>
        <div className='dialog__header'>
          <span className='dialog__title'>
            {this.dayWorkerType(this.state.dayWorkerType)}
          </span>
        </div>
        <div className='dialog__body'>
          {_.map(this.state.approvalPersonList, workApproval =>
            this.renderStamp(workApproval)
          )}
        </div>
        <div className='dialog__footer'>
          <button
            id='modal-close-unconfirmed'
            className='btn--sub'
            onClick={() => {
              this.props.onClose();
            }}
          >
            戻る
          </button>
        </div>
      </div>
    );
  }
}

export default WorkApproval;



// WEBPACK FOOTER //
// ./src/components/modals/WorkApproval.jsx